import { Directive } from '@angular/core'

import { ThemeComponent } from '@flowx/core-theme'

import { FlxComponentThemeBaseDirective } from './component-theme-base.directive'

import { ComponentType } from '../injectors'

@Directive({
  selector: 'flx-card, flx-accordion-item',
  standalone: true,
  hostDirectives: [FlxComponentThemeBaseDirective],
  providers: [{ provide: ComponentType, useValue: ThemeComponent.Card }],
})
export class FlxCardThemeDirective {}
